import React from "react";
import { IApplication } from "../../../Interfaces/Application/IApplication";
import CardHeader from "@mui/material/CardHeader";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { TabName } from "./OrderEditorTabs";
import { BureauFavorite } from "../../../Data/BureauFavorites";
import { Constants } from "../../../utils/constants";
import { IEntityCustomField } from "../../../Interfaces/Application/IEntityCustomField";
import { customerCreditSections } from "../../../Interfaces/Customer/ICustomerCredit";
import { Tooltip } from "@mui/material";
import { isNotNil } from "ramda";
import { hasValue } from "@amsanalytics/react-shared-library";
import { IConfiguration } from "../../../Data/ConfigurationData";

export interface CustomerCreditBreakdownCardProps {
  currentApp: IApplication;
  favorites: BureauFavorite[];
  configuration: IConfiguration | undefined;
  navigate: (tabName: TabName) => void;
}

export const CustomerCreditBreakdownCard = (props: CustomerCreditBreakdownCardProps) => {
  const customerCredit = props.currentApp.appCustomers.find(ac => ac.customerRoleId.toLowerCase() === Constants.roleApplicantId.toLowerCase())?.customer.customerCredit[0];
  
  return (
    <Card>
      <CardHeader
        avatar={<CreditCardIcon fontSize="small" />}
        title="Customer Credit Breakdown"
        action={
          <>
            <IconButton size="small" onClick={() => props.navigate("Bureau")}>
              <EditIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
      <Divider variant="middle" />
      <CardContent>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {props.favorites.map((favorite: BureauFavorite, idx: number) => {
            // Find the primary customer credit.
            const overrideValue = (props.currentApp.appCustomers.find(ac => ac.customerRoleId.toLowerCase() === Constants.roleApplicantId.toLowerCase())?.customer.customerCustomFields ?? [] as IEntityCustomField[])?.find(cf => cf.customField.customerCreditOverrideField?.toLowerCase() === customerCreditSections.find(section => section.customerCreditRows.some(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase()))?.customerCreditRows.find(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase())?.variableName?.toLowerCase())?.value;
            const variableNameForValueLookup: string | undefined = customerCreditSections.find(section => section?.customerCreditRows.some(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase()))?.customerCreditRows.find(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase())!.variableName;
            // If no override value exists, use the customer credit value.
            const value = isNotNil(customerCredit) && variableNameForValueLookup ? customerCredit[variableNameForValueLookup] : undefined;
            return (
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', borderBottom: 'solid 1px #e0e0e0' }} key={idx}>
                <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#1f1d1d' }}>{customerCreditSections.find(section => section.customerCreditRows.some(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase()))?.customerCreditRows.find(row => row.itemTitle.toLowerCase() === favorite.fieldName.toLowerCase())?.itemTitle}:</div>
                {hasValue(overrideValue) && (
                  <Tooltip title={`Original 700Credit value: ${value}`} placement="right">
                    <div>{overrideValue}</div>
                  </Tooltip>
                )}
                {!hasValue(overrideValue) && (
                  <div>{value}</div>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}